import { render, staticRenderFns } from "./ButtonSendToBudget.vue?vue&type=template&id=caab3c2a&"
import script from "./ButtonSendToBudget.vue?vue&type=script&lang=ts&"
export * from "./ButtonSendToBudget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports